import { Dispatch, SetStateAction, useState } from 'react';
import styled from 'styled-components';

export interface ListData {
  label: string;
  value: string | number;
  hasToggleButton?: boolean;
  isArea?: boolean;
  value_p?: string | number; // 평
  isAddress?: boolean;
  hasPercentBadge?: boolean;
  percent?: string;
  isBold?: boolean;
  unitItem?: 'm' | '평';
  setUnitItem?: Dispatch<SetStateAction<'m' | '평'>>;
  deleteAreaUnit?: boolean;
}

interface Props {
  data: ListData[];
}

function ListContent({ data }: Props) {
  const [unit, setUnit] = useState('m');

  const toggleUnit = (item: ListData) => {
    if (item.unitItem && item.setUnitItem) {
      item.setUnitItem((prev) => (prev === 'm' ? '평' : 'm'));
    } else {
      setUnit((prev) => (prev === 'm' ? '평' : 'm'));
    }
  };

  const handleCopyAddress = (address: string) => {
    navigator.clipboard
      .writeText(address)
      .then(() => {
        alert('주소가 복사되었습니다!');
      })
      .catch((err) => {
        console.error('주소 복사에 실패했습니다:', err);
        alert('주소 복사에 실패했습니다.');
      });
  };

  if (data.length === 0) {
    return <EmptyMessage>데이터가 없습니다.</EmptyMessage>;
  }

  return (
    <List>
      {data.map((item, idx) => (
        <Item key={idx}>
          <ItemLabel>{item.label}</ItemLabel>
          <ItemContent label={item.label} $idBold={item.isBold}>
            {item.isArea
              ? unit === 'm'
                ? `${item.value}${!item.deleteAreaUnit ? 'm²' : ''}`
                : `${item.value_p}${!item.deleteAreaUnit ? '평' : ''}`
              : item.value}

            {/* 평 <-> m² 토글 버튼 */}
            {item.hasToggleButton && (
              <ChangeUnitButton onClick={() => toggleUnit(item)}>
                <img src="/assets/images/icon/refresh.svg" alt="switch" />
                {item.isArea
                  ? unit === 'm'
                    ? '평'
                    : 'm²'
                  : item.unitItem === 'm'
                    ? '평'
                    : 'm²'}
              </ChangeUnitButton>
            )}

            {/* 주소복사 버튼 */}
            {item.isAddress && (
              <CopyAddress
                onClick={() => handleCopyAddress(String(item.value))}
              >
                <img
                  src="/assets/images/icon/copy-blue.svg"
                  alt=""
                  width={16}
                  height={16}
                />
                <span>주소복사</span>
              </CopyAddress>
            )}

            {item.hasPercentBadge && (
              <PercentBadge label={item.label}>{item.percent}%</PercentBadge>
            )}
          </ItemContent>
        </Item>
      ))}
    </List>
  );
}

export default ListContent;

const List = styled.div`
  display: flex;
  flex-direction: column;
`;

const Item = styled.div`
  display: flex;
  flex-direction: row;
  gap: 8px;
  justify-content: space-between;
  padding: 12px 0;
  border-bottom: 1px solid #f3f5f7;
  align-items: center;
`;

const ItemLabel = styled.div`
  font-weight: 500;
  font-size: 13px;
  line-height: 145%;
  letter-spacing: -2%;
  text-align: center;
  color: #616161;
  white-space: nowrap;
`;

const ItemContent = styled.div<{ label: string; $idBold?: boolean }>`
  display: flex;
  flex-direction: row;
  gap: 4px;
  justify-content: flex-end;
  white-space: pre-wrap;

  font-weight: ${({ $idBold }) => ($idBold ? 700 : 500)};
  font-size: 14px;
  line-height: 145%;
  letter-spacing: -2%;
  text-align: end;
  color: ${({ label }) => (label === '최저가' ? '#008AFF' : '#222')};
`;
const ChangeUnitButton = styled.button`
  display: flex;
  padding: 2px 4px;
  align-items: center;
  justify-content: center;
  gap: 2px;
  border-radius: 4px;
  border: 1px solid #e5e8ea;
  background: #fff;

  color: #616161;
  font-family: Pretendard;
  font-size: 12px;
  font-style: normal;
  font-weight: 500;
  line-height: 16px;
`;

const CopyAddress = styled.div`
  display: flex;
  align-items: center;
  gap: 2px;
  color: #008aff;
  font-size: 12px;
  font-weight: 500;
  line-height: 145%; /* 17.4px */
  letter-spacing: -0.24px;
  white-space: nowrap;
`;

const PercentBadge = styled.div<{ label?: string }>`
  padding: 1px 6px;
  border-radius: 4px;

  background: ${({ label }) =>
    label === '최저가' ? '#008AFF0F' : '#70737C14'};
  color: ${({ label }) => (label === '최저가' ? '#008aff' : '#37383C9C')};
  font-size: 12px;
  font-weight: 700;
  line-height: 145%; /* 17.4px */
  letter-spacing: -0.24px;
`;

const EmptyMessage = styled.div`
  font-weight: 500;
  font-size: 14px;
  width: 100%;
  text-align: center;
  color: #616161;
`;
